import {
  Directive,
  Input,
  OnInit,
  OnDestroy,
  ElementRef,
  Renderer2,
} from '@angular/core';
import { AuthService } from '@data/services/modules/auth/auth.service';
import { MessageService } from 'primeng/api';

@Directive({
  selector: '[appHasPermission]'
})
export class HasPermissionDirective implements OnInit, OnDestroy {
  @Input('appHasPermission') appHasPermission!: [string, string] | string;
  private hasPermission: boolean = false;
  private clickHandler: (event: Event) => void;

  constructor(
    private authService: AuthService,
    private messageService: MessageService,
    private el: ElementRef,
    private renderer: Renderer2
  ) {
    // Creamos el manejador de clics en el constructor para poder removerlo en ngOnDestroy
    this.clickHandler = this.onClick.bind(this);
  }

  ngOnInit() {
    if (
      Array.isArray(this.appHasPermission) &&
      this.appHasPermission.length === 2
    ) {
      const [module, permission] = this.appHasPermission;
      this.hasPermission = this.authService.hasModulePermission(module, permission);
    } else if (typeof this.appHasPermission === 'string') {
      // Asume que el permiso por defecto es 'get-all'
      this.hasPermission = this.authService.hasModulePermission(
        this.appHasPermission,
        'get-all'
      );
    }

    if (!this.hasPermission) {
      this.renderer.setProperty(this.el.nativeElement, 'disabled', true);
      this.renderer.setStyle(this.el.nativeElement, 'opacity', '0.5');
      this.renderer.setStyle(this.el.nativeElement, 'cursor', 'not-allowed');

      // Añadimos el listener en la fase de captura para interceptar el clic antes de Angular
      this.el.nativeElement.addEventListener('click', this.clickHandler, true);
    }
  }

  ngOnDestroy() {
    if (!this.hasPermission) {
      // Remover el listener de clic cuando la directiva se destruye
      this.el.nativeElement.removeEventListener('click', this.clickHandler, true);
    }
  }

  private onClick(event: Event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();

    this.messageService.add({
      severity: 'error',
      summary: 'Permiso Denegado',
      detail: 'No tienes permiso para realizar esta acción.'
    });
  }
}
